

export async function handleResponse(resp) {

    var response = resp; 

    if (response.ok) {
        return response.json();
    }

    if (response.status === 401) {
        throw new Error("401"); 
    }

    if (response.status === 400) {
        const error = await response.json();
        throw new Error(error.Message); 
    }

    if (response.status === 404) {

        throw new Error("404"); 
    }

    if (response.status === 500) {
        throw new Error("There has been a problem processing your request. Please try again later");
    }
}

//This needs to properly log the error! 
export function handleError(error) {
    console.error("API call failed " + error);
    throw error; 
}



// WEBPACK FOOTER //
// ./src/api/apiUtils.js